var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bl_logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 1155.2368,
    viewBox: "0 0 1000 1155.2368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2999"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 86.555,267.144 503.189,0 0,383.056 -503.189,0 0,-383.056 z",
    id: "path3001"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3151"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 676.299,0 0,922.913 L 0,922.913 0,0 z",
    id: "path3153"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3759"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 33,2470.89 3483.05,0 L 3516.05,33 33,33 33,2470.89 z",
    id: "path3761"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath5402"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 108.825,6.899 29.075,0 0,33.593 -29.075,0 0,-33.593 z",
    id: "path5404"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2993",
    transform: "matrix(1.25,0,0,-1.25,-781.6367,2721.5462)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(28.521771,0,0,28.521771,-2496.5518,1038.2935)",
    id: "g5398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5400",
    clipPath: "url(#clipPath5402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5406",
    transform: "translate(109.8784,30.7636)",
    style: {
      fill: "#760135",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 0,4.608 c 0,0.515 0,0.882 -0.409,1.25 l 2.813,0 C 2.005,5.49 1.995,5.123 1.995,4.608 l 0,-4.66 c 0.388,-0.126 0.755,-0.189 1.144,-0.189 0.525,0 0.966,0.157 1.438,0.482 l -0.378,-1.5 -4.608,0 C -0.01,-0.882 0,-0.504 0,0",
    style: {
      fill: "#760135",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5408"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5410",
    transform: "translate(117.2774,29.5042)",
    style: {
      fill: "#760135",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -2.813,0 c 0.399,0.378 0.409,0.756 0.409,1.259 l 0,4.609 c 0,0.514 0,0.882 -0.409,1.249 L 0,7.117 C -0.399,6.75 -0.409,6.382 -0.409,5.868 l 0,-4.609 C -0.409,0.756 -0.399,0.378 0,0",
    style: {
      fill: "#760135",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5412"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5414",
    transform: "translate(121.4335,30.3753)",
    style: {
      fill: "#760135",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 1.102,0 1.847,0.84 1.847,2.362 1.847,4.168 1.029,5.28 -0.126,5.28 -1.207,5.28 -1.963,4.44 -1.963,2.929 -1.963,1.113 -1.145,0 0,0 m -4.084,2.698 c 0,0.976 0.452,1.973 1.271,2.708 0.735,0.651 1.7,1.008 2.75,1.008 2.383,0 4.031,-1.543 4.031,-3.727 0,-0.976 -0.452,-1.994 -1.27,-2.718 -0.735,-0.662 -1.701,-1.008 -2.761,-1.008 -2.362,0 -4.021,1.564 -4.021,3.737",
    style: {
      fill: "#760135",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5416"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5418",
    transform: "translate(125.8694,31.2888)",
    style: {
      fill: "#760135",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 0,3.821 c 0,0.504 -0.01,0.913 -0.567,1.512 l 2.194,0 3.233,-4.357 0,2.488 0,0.325 c 0,0.483 -0.042,0.945 -0.504,1.544 L 6.393,5.332 C 6.005,4.692 5.973,4.22 5.973,3.758 l 0,-0.294 0,-5.427 C 4.43,-1.785 3.916,-1.05 3.264,-0.2 l -2.151,2.803 0,-2.603 0,-0.42 c 0,-0.546 0.042,-0.945 0.472,-1.365 l -2.079,0 C 0,-1.249 0,-0.746 0,0",
    style: {
      fill: "#760135",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5420"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5422",
    transform: "translate(134.4771,30.4909)",
    style: {
      fill: "#760135",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.672,0 1.081,0.346 1.081,0.788 0,0.671 -0.734,0.86 -1.732,1.374 -0.987,0.504 -1.501,1.229 -1.501,2.068 0,1.207 0.976,2.069 2.614,2.069 0.609,0 1.176,-0.116 1.785,-0.336 l 0,-1.197 C 1.648,5.07 1.165,5.249 0.766,5.249 c -0.567,0 -0.934,-0.315 -0.934,-0.693 0,-0.588 0.756,-0.798 1.984,-1.47 0.819,-0.451 1.197,-1.07 1.197,-1.931 0,-1.334 -1.103,-2.257 -2.803,-2.257 -0.704,0 -1.386,0.136 -2.11,0.378 L -2.267,0.788 C -1.438,0.283 -0.735,0 0,0",
    style: {
      fill: "#760135",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5424"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5426",
    transform: "translate(115.4546,37.8234)",
    style: {
      fill: "#30469d",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.211,0 0.355,0.165 0.355,0.39 0,0.253 -0.144,0.411 -0.358,0.411 -0.032,0 -0.078,-0.007 -0.137,-0.014 l 0,-0.773 C -0.074,0.004 -0.028,0 0,0 M -0.046,1.128 C 0.106,1.128 0.2,1.234 0.2,1.413 0.2,1.564 0.106,1.68 -0.038,1.68 -0.056,1.68 -0.091,1.677 -0.14,1.669 l 0,-0.534 c 0.042,-0.007 0.073,-0.007 0.094,-0.007 m -0.769,-1.05 0,1.542 c 0,0.173 -0.004,0.296 -0.137,0.419 l 0.885,0 c 0.598,0 0.9,-0.211 0.9,-0.563 C 0.833,1.269 0.71,1.104 0.475,1.002 0.794,0.907 0.963,0.696 0.963,0.38 0.963,0.193 0.896,0.021 0.773,-0.112 0.59,-0.306 0.38,-0.344 0.074,-0.344 l -1.026,0 c 0.133,0.126 0.137,0.253 0.137,0.422",
    style: {
      fill: "#30469d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5428"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5430",
    transform: "translate(118.1058,39.1485)",
    style: {
      fill: "#30469d",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,0.218 -0.127,0.355 -0.337,0.355 -0.018,0 -0.036,0 -0.053,-0.003 l 0,-0.812 C -0.134,-0.394 0,-0.232 0,0 m -1.195,-1.669 c 0.133,0.126 0.137,0.252 0.137,0.421 l 0,1.543 c 0,0.173 0,0.295 -0.137,0.419 l 0.928,0 c 0.615,0 0.924,-0.208 0.924,-0.637 0,-0.256 -0.141,-0.439 -0.436,-0.58 L 0.654,-1.241 C 0.72,-1.353 0.822,-1.487 0.97,-1.638 L 0.573,-1.677 C 0.541,-1.68 0.51,-1.68 0.478,-1.68 c -0.264,0 -0.404,0.13 -0.559,0.429 l -0.309,0.604 0,-0.601 c 0,-0.169 0.003,-0.295 0.137,-0.421 l -0.942,0 z",
    style: {
      fill: "#30469d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5432"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5434",
    transform: "translate(120.2849,37.479)",
    style: {
      fill: "#30469d",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -0.942,0 c 0.134,0.127 0.137,0.253 0.137,0.422 l 0,1.543 c 0,0.172 0,0.295 -0.137,0.418 L 0,2.383 C -0.134,2.26 -0.137,2.137 -0.137,1.965 l 0,-1.543 C -0.137,0.253 -0.134,0.127 0,0",
    style: {
      fill: "#30469d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5436"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5438",
    transform: "translate(121.5221,37.8094)",
    style: {
      fill: "#30469d",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.225,0 0.362,0.116 0.362,0.263 0,0.225 -0.246,0.289 -0.58,0.461 -0.33,0.169 -0.503,0.411 -0.503,0.692 0,0.405 0.327,0.693 0.876,0.693 0.204,0 0.393,-0.039 0.597,-0.113 l 0,-0.4 c -0.2,0.102 -0.362,0.161 -0.495,0.161 -0.19,0 -0.313,-0.105 -0.313,-0.232 0,-0.196 0.253,-0.267 0.664,-0.492 0.274,-0.151 0.401,-0.358 0.401,-0.646 0,-0.447 -0.369,-0.756 -0.939,-0.756 -0.235,0 -0.464,0.046 -0.706,0.127 L -0.759,0.263 C -0.482,0.095 -0.246,0 0,0",
    style: {
      fill: "#30469d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5440"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5442",
    transform: "translate(123.9096,37.8234)",
    style: {
      fill: "#30469d",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.211,0 0.355,0.165 0.355,0.39 0,0.253 -0.144,0.411 -0.359,0.411 -0.031,0 -0.077,-0.007 -0.137,-0.014 l 0,-0.773 C -0.074,0.004 -0.028,0 0,0 m -0.046,1.128 c 0.151,0 0.246,0.106 0.246,0.285 0,0.151 -0.095,0.267 -0.238,0.267 -0.018,0 -0.053,-0.003 -0.103,-0.011 l 0,-0.534 c 0.043,-0.007 0.074,-0.007 0.095,-0.007 m -0.769,-1.05 0,1.542 c 0,0.173 -0.004,0.296 -0.138,0.419 l 0.886,0 c 0.598,0 0.9,-0.211 0.9,-0.563 C 0.833,1.269 0.71,1.104 0.474,1.002 0.794,0.907 0.963,0.696 0.963,0.38 0.963,0.193 0.896,0.021 0.773,-0.112 0.59,-0.306 0.38,-0.344 0.074,-0.344 l -1.027,0 c 0.134,0.126 0.138,0.253 0.138,0.422",
    style: {
      fill: "#30469d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5444"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5446",
    transform: "translate(126.4165,38.5194)",
    style: {
      fill: "#30469d",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -0.242,0.735 -0.488,0 0,0 z m -1.121,-0.685 0.559,1.599 c 0.021,0.063 0.052,0.123 0.052,0.2 0,0.081 -0.042,0.144 -0.115,0.229 l 0.843,0 0.675,-1.955 C 0.953,-0.78 1.044,-0.931 1.156,-1.04 l -1.033,0 c 0.081,0.091 0.127,0.151 0.127,0.246 0,0.049 -0.007,0.091 -0.018,0.119 l -0.12,0.341 -0.716,0 -0.113,-0.327 c -0.018,-0.056 -0.032,-0.102 -0.032,-0.144 0,-0.084 0.039,-0.162 0.113,-0.235 l -0.699,0 c 0.094,0.112 0.168,0.225 0.214,0.355",
    style: {
      fill: "#30469d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5448"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5450",
    transform: "translate(127.9315,38.0766)",
    style: {
      fill: "#30469d",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 0,1.279 c 0,0.169 -0.003,0.306 -0.19,0.506 l 0.735,0 1.082,-1.458 0,0.833 0,0.109 c 0,0.161 -0.014,0.316 -0.168,0.516 l 0.681,0 C 2.01,1.571 2,1.413 2,1.258 L 2,1.16 2,-0.657 c -0.517,0.059 -0.689,0.305 -0.907,0.59 l -0.721,0.938 0,-0.871 0,-0.141 c 0,-0.183 0.015,-0.316 0.159,-0.457 l -0.696,0 C 0,-0.418 0,-0.25 0,0",
    style: {
      fill: "#30469d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5452"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5454",
    transform: "translate(130.7116,37.9009)",
    style: {
      fill: "#30469d",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 0,1.543 c 0,0.172 0,0.295 -0.137,0.418 l 1.395,0 0,-0.495 C 1.139,1.578 1.051,1.603 0.917,1.603 l -0.242,0 0,-0.594 0.457,0 0,-0.457 C 1.076,0.629 0.988,0.671 0.875,0.671 l -0.2,0 0,-0.717 c 0.088,-0.018 0.176,-0.032 0.264,-0.032 0.238,0 0.421,0.043 0.597,0.176 l -0.127,-0.52 -1.546,0 C -0.003,-0.295 0,-0.169 0,0",
    style: {
      fill: "#30469d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5456"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5458",
    transform: "translate(122.8524,31.6595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,0 -1.865,0.239 -3.787,-0.532 0,0 0.255,-0.284 0.223,-0.473 0,0 -2.664,-0.587 -3.631,-2.246 0,0 0.383,-0.032 0.479,-0.284 0,0 -2.042,-1.325 -2.106,-2.681 0,0 0.765,-0.221 0.35,-0.568 -0.414,-0.347 -1.755,-0.915 -1.818,-1.703 0,0 0.826,0.049 0.606,-0.726 -0.075,-0.267 -0.238,-0.94 -0.238,-1.86 0,-7.692 10.574,-13.043 10.574,-13.043 0,0 10.586,5.351 10.586,13.043 -0.002,0.185 -0.051,1.826 -0.564,2.712 0,0 0.171,0.116 0.351,0.095 0,0 -0.075,0.807 -0.982,1.806 -0.406,0.447 -0.53,1.229 0.025,1.285 0,0 -0.064,0.482 -1.139,0.657 -0.259,0.043 -0.291,0.032 -0.444,0.285 -0.14,0.23 -0.24,0.762 -0.063,1.099 0,0 -0.416,0.171 -0.726,-0.005 0,0 -0.883,1.938 -1.968,2.222 0,0 -0.016,-0.184 -0.183,-0.29 0,0 -1.373,1.563 -2.71,1.612 0,0 0.012,-0.245 -0.113,-0.42 0,0 -1.476,0.448 -2.753,0.4 0,0 0.117,-0.225 0.031,-0.385",
    style: {
      fill: "#fab93d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5460"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5462",
    transform: "translate(115.9789,24.7565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,0 -0.435,-0.217 -1.113,-0.264 0,0 0.43,-0.336 1.201,-0.326 0,0 -0.067,0.3 -0.088,0.59",
    style: {
      fill: "#a20641",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5464"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5466",
    transform: "translate(133.735,20.1051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.37,3.363 -1.997,4.741 -1.997,4.741 0.716,0.055 1.276,-0.526 1.276,-0.526 -1.153,2.238 -2.342,2.724 -2.853,2.827 0.731,-0.454 1.24,-1.614 0.58,-3.716 -0.68,1.174 -1.359,1.487 -1.359,1.487 0.367,0.208 0.943,-0.112 0.943,-0.112 -0.447,1.088 -1.551,1.056 -1.551,1.056 0.464,0.415 1.231,0.128 1.231,0.128 -0.904,0.881 -2.334,0.51 -2.334,0.51 0,0 0.725,0.931 1.778,0.874 0.158,-0.009 0.32,-0.043 0.477,-0.107 0.172,0.613 0.783,0.794 0.783,0.794 -1.024,0.303 -2.231,-0.48 -2.231,-0.48 0.487,1.12 0.36,2.207 0.36,2.207 -0.799,-2.133 -1.869,-3.07 -1.869,-3.07 0.977,1.915 -0.167,4.369 -0.167,4.369 0.393,-2.562 -0.875,-3.934 -0.875,-3.934 0.223,3.085 -1.123,4.042 -1.123,4.042 1.014,-1.563 0.171,-3.809 0.171,-3.809 -0.601,3.121 -3.183,3.737 -3.183,3.737 2.536,-1.548 2.158,-4.643 2.158,-4.643 -0.476,2.526 -2.479,3.551 -2.479,3.551 1.211,-1.149 1.392,-3.095 1.392,-3.095 -1.848,3.731 -5.129,2.795 -5.129,2.795 3.121,-0.285 3.845,-2.821 3.845,-2.821 -1.92,2.52 -4.549,1.749 -4.549,1.749 1.992,-0.124 2.758,-1.625 2.758,-1.625 -2.551,1.956 -4.808,-0.549 -4.808,-0.549 0.722,0.24 0.999,-0.16 0.999,-0.16 -0.782,-0.363 -1.113,-0.968 -1.113,-0.968 0.725,0.217 1.097,0.072 1.097,0.072 0.006,0.192 0.125,1.553 1.243,1.879 1.233,0.36 2.122,-0.812 2.122,-0.812 -1.605,0.341 -2.319,-0.508 -2.319,-0.508 0.859,0.285 1.216,-0.134 1.216,-0.134 -1.226,-0.047 -1.546,-1.048 -1.546,-1.048 0.657,0.327 0.946,0.106 0.946,0.106 -1.7,-1.708 -3.73,-1.121 -3.73,-1.121 1.553,-1.014 3.468,-0.468 3.468,-0.468 -1.62,-1.193 -3.7,-0.819 -3.7,-0.819 2.083,-1.192 3.258,-0.7 3.258,-0.7 -0.839,-1.204 -3.395,-1.131 -3.395,-1.131 1.583,-1.025 3.395,-0.456 3.395,-0.456 -0.479,-0.727 -1.491,-0.828 -1.491,-0.828 1.041,-0.474 1.739,-0.248 1.739,-0.248 -0.817,-0.805 -2.627,-0.459 -2.627,-0.459 1.401,-1.141 3.248,-0.722 3.248,-0.722 -1.876,-1.312 -3.871,-0.126 -3.871,-0.126 1.418,-1.514 3.997,-1.375 3.997,-1.375 -0.987,-0.683 -2.198,-0.416 -2.198,-0.416 1.004,-0.834 1.796,-0.795 1.796,-0.795 -1.118,-0.483 -2.492,0.1 -2.492,0.1 1.172,-1.44 3.334,-1.367 3.334,-1.367 -0.7,-0.467 -1.967,-0.216 -1.967,-0.216 1.808,-1.216 3.382,-0.936 3.382,-0.936 -1.424,-0.565 -2.518,-0.216 -2.518,-0.216 1.829,-0.98 2.934,-0.887 2.934,-0.887 -0.639,-0.479 -1.24,-0.31 -1.24,-0.31 0,0 1.276,-1.028 2.158,-1.682 1.535,-1.049 2.4,-1.497 2.4,-1.497 4.831,2.732 4.486,4.209 4.486,4.209 0.359,-0.317 0.457,-0.768 0.457,-0.768 1.682,1.396 1.868,3.312 1.868,3.312 0.404,-0.761 -0.034,-1.891 -0.034,-1.891 1.944,2.123 1.259,4.228 1.259,4.228 0.579,-0.207 0.662,-1.57 0.662,-1.57 1.999,3.453 0.127,6.15 0.127,6.15 C -0.732,1.592 0,0 0,0",
    style: {
      fill: "#a20641",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5468"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5470",
    transform: "translate(133.735,20.1051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.37,3.363 -1.997,4.741 -1.997,4.741 0.716,0.055 1.276,-0.526 1.276,-0.526 -1.153,2.238 -2.342,2.724 -2.853,2.827 0.731,-0.454 1.24,-1.614 0.58,-3.716 -0.68,1.174 -1.359,1.487 -1.359,1.487 0.367,0.208 0.943,-0.112 0.943,-0.112 -0.447,1.088 -1.551,1.056 -1.551,1.056 0.464,0.415 1.231,0.128 1.231,0.128 -0.904,0.881 -2.334,0.51 -2.334,0.51 -0.228,-0.042 -0.304,-0.061 -0.304,-0.061 0,0 -1.149,0.16 -2.308,-0.233 -1.369,-0.465 -1.471,-1.972 -1.556,-1.972 -0.084,0 -0.192,1.507 -1.56,1.972 -1.16,0.393 -2.309,0.233 -2.309,0.233 0,0 0.706,-0.157 0.693,-0.396 -0.008,-0.151 -0.252,-0.194 -0.517,-0.251 -0.133,-0.029 -0.667,-0.161 -0.935,-0.439 0,0 0.608,0.096 0.688,-0.075 0.098,-0.209 -0.606,-0.575 -1.441,-0.879 0,0 0.373,0.022 0.466,-0.186 0.121,-0.274 -0.174,-0.63 -0.292,-0.797 -1.265,-1.791 -0.795,-3.268 -0.201,-4.304 0.403,-0.701 1.632,-2.666 1.632,-2.666 0,0 -0.236,-0.469 -0.184,-1.108 0.069,-0.842 0.069,-1.235 0.452,-1.684 0.136,-0.158 0.466,-0.6 0.425,-1.035 -0.054,-0.57 0.124,-1.129 0.735,-1.553 0,0 0.083,0.207 0.238,0.248 0,0 0.168,-0.276 0.797,-0.61 0.791,-0.421 1.251,-0.848 1.302,-2.461 0.008,-0.004 0.013,-0.006 0.013,-0.006 4.831,2.732 4.486,4.209 4.486,4.209 0.359,-0.317 0.457,-0.768 0.457,-0.768 1.682,1.396 1.868,3.312 1.868,3.312 0.404,-0.761 -0.034,-1.891 -0.034,-1.891 1.944,2.123 1.259,4.228 1.259,4.228 0.579,-0.207 0.662,-1.57 0.662,-1.57 1.999,3.453 0.127,6.15 0.127,6.15 C -0.732,1.592 0,0 0,0",
    style: {
      fill: "#760135",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5472"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5474",
    transform: "translate(129.4458,20.5326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.146,0.789 0.032,1.91 -0.733,2.883 -0.081,0.103 -0.578,0.707 -0.908,1.1 -0.189,0.225 -0.493,0.512 -0.435,0.681 0.098,0.283 0.757,0.157 0.757,0.157 -0.238,0.273 -0.723,0.376 -0.936,0.438 -0.229,0.067 -0.509,0.1 -0.517,0.251 -0.012,0.239 0.693,0.396 0.693,0.396 0,0 -1.149,0.16 -2.308,-0.233 -1.369,-0.464 -1.471,-1.972 -1.556,-1.972 -0.084,0 -0.191,1.508 -1.56,1.972 -1.159,0.393 -2.309,0.233 -2.309,0.233 0,0 0.706,-0.157 0.694,-0.396 -0.009,-0.151 -0.253,-0.194 -0.517,-0.251 -0.133,-0.029 -0.668,-0.16 -0.936,-0.438 0,0 0.609,0.095 0.688,-0.076 0.098,-0.209 -0.606,-0.575 -1.441,-0.878 0,0 0.373,0.022 0.466,-0.187 0.121,-0.274 -0.173,-0.63 -0.292,-0.797 -1.264,-1.791 -0.795,-3.268 -0.201,-4.303 0.403,-0.702 1.633,-2.666 1.633,-2.666 0.263,0.543 0.74,0.65 0.74,0.65 -0.318,-0.193 -0.488,-0.501 -0.577,-0.81 0.186,0.019 0.374,0.029 0.565,0.029 0.524,0 1.032,-0.073 1.512,-0.211 0.048,-0.014 0.124,-0.078 0.093,-0.179 -0.032,-0.102 -0.135,-0.103 -0.177,-0.089 -0.532,0.174 -1.1,0.269 -1.69,0.269 -0.797,0 -1.554,-0.172 -2.235,-0.481 l 0.017,-0.05 c 0.572,0.248 1.197,0.397 1.854,0.427 -0.018,-0.123 -0.026,-0.239 -0.029,-0.342 0.214,0.029 0.433,0.044 0.655,0.044 0.448,0 0.882,-0.061 1.294,-0.175 0.049,-0.013 0.123,-0.075 0.098,-0.172 -0.027,-0.1 -0.133,-0.113 -0.174,-0.1 -0.466,0.151 -0.963,0.233 -1.48,0.233 -0.726,0 -1.415,-0.162 -2.033,-0.452 l 0.017,-0.048 c 0.502,0.224 1.052,0.362 1.629,0.394 0.005,-0.071 0.027,-0.249 0.041,-0.336 -10e-4,0 -0.002,0 -0.002,0 0.199,0.028 0.403,0.044 0.61,0.044 0.371,0 0.731,-0.048 1.074,-0.138 0.051,-0.013 0.128,-0.071 0.102,-0.168 -0.029,-0.112 -0.135,-0.115 -0.177,-0.102 -0.399,0.125 -0.822,0.192 -1.262,0.191 -0.655,-0.002 -1.276,-0.155 -1.828,-0.426 l 0.016,-0.047 c 0.464,0.215 0.976,0.345 1.515,0.368 0.024,-0.132 0.046,-0.25 0.058,-0.317 0.104,-0.616 0.727,-0.821 1.156,-0.617 0.03,0.014 1.555,0.741 1.605,0.764 0.423,0.192 0.729,0.594 0.79,1.073 0.06,-0.479 0.367,-0.881 0.79,-1.073 0.05,-0.023 1.574,-0.75 1.605,-0.764 0.429,-0.204 1.052,0.001 1.156,0.617 0.014,0.083 0.035,0.194 0.057,0.317 0.539,-0.023 1.051,-0.153 1.516,-0.368 l 0.016,0.047 c -0.553,0.271 -1.173,0.424 -1.829,0.426 -0.44,0.001 -0.865,-0.066 -1.265,-0.192 -0.041,-0.012 -0.139,-0.007 -0.172,0.093 -0.031,0.095 0.046,0.164 0.095,0.177 0.345,0.09 0.707,0.139 1.08,0.139 0.205,0 0.407,-0.015 0.605,-0.044 0.003,0.021 0.033,0.206 0.045,0.336 0.576,-0.032 1.125,-0.17 1.628,-0.394 l 0.016,0.048 c -0.618,0.29 -1.307,0.452 -2.033,0.452 -0.516,0 -1.013,-0.082 -1.479,-0.233 -0.041,-0.013 -0.144,-0.003 -0.172,0.095 -0.029,0.099 0.045,0.164 0.093,0.177 0.413,0.114 0.848,0.175 1.297,0.175 0.223,0 0.444,-0.016 0.66,-0.045 -0.002,0.105 -0.01,0.22 -0.029,0.342 0.654,-0.029 1.278,-0.178 1.849,-0.426 l 0.017,0.05 c -0.682,0.309 -1.439,0.481 -2.236,0.481 -0.591,0 -1.16,-0.095 -1.693,-0.27 -0.041,-0.014 -0.15,-0.003 -0.176,0.097 -0.024,0.093 0.044,0.157 0.091,0.171 0.482,0.138 0.99,0.212 1.517,0.212 0.192,0 0.382,-0.01 0.569,-0.029 -10e-4,0 -0.002,0 -0.002,0 -0.016,0.054 -0.034,0.109 -0.055,0.164 -0.255,0.664 -0.902,0.812 -0.902,0.812 0,0 0.33,0.391 0.073,1.02 l -0.344,0.815 c 0,0 0.58,-0.461 1.394,-0.477 C -0.757,-1.94 -0.14,-0.757 0,0",
    style: {
      fill: "#fab93d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5476"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5478",
    transform: "translate(123.0479,11.9556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,0 -0.241,-0.125 -0.354,-0.419 0,0 -0.311,0.205 -0.343,0.559 0,0 -0.325,-0.125 -0.452,-0.43 0,0 -0.339,0.135 -0.337,0.532 0,0 -0.226,-0.133 -0.341,-0.404 0,-0.001 -0.39,0.478 -0.346,0.955 0.056,0.628 0.553,0.833 0.626,0.869 0.072,0.036 1.221,0.585 1.278,0.609 C -0.058,2.36 0.185,2.423 0.45,2.423 0.715,2.423 0.958,2.36 1.169,2.271 1.226,2.247 2.375,1.698 2.447,1.662 2.519,1.626 3.019,1.421 3.073,0.793 3.113,0.327 2.758,-0.124 2.727,-0.162 c 0,0 -0.091,0.241 -0.341,0.404 0,0 -0.041,-0.37 -0.337,-0.532 0,0 -0.099,0.279 -0.452,0.43 0,0 -0.006,-0.311 -0.344,-0.559 0,0 -0.083,0.266 -0.412,0.419 0,0 -0.025,-0.393 -0.457,-0.646 0,0 -0.107,0.522 -0.384,0.646",
    style: {
      fill: "#fab93d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5480"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5482",
    transform: "translate(128.2673,22.2004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.011,0.028 -0.032,0.045 -0.06,0.048 l -0.025,0.066 -10e-4,0 c 0.018,0.013 0.053,0.047 0.045,0.118 -0.011,0.093 -0.082,0.128 -0.143,0.14 -0.399,0.079 -0.611,0.235 -0.741,0.328 -0.131,0.092 -0.223,0.138 -0.385,0.138 -0.5,0 -1.442,-0.734 -1.727,-0.734 -0.096,0 -0.145,0.07 -0.157,0.089 -10e-4,0.002 -0.002,0.004 -0.002,0.006 -0.339,-0.474 -0.138,-0.936 -10e-4,-1.273 0.032,-0.077 0.582,-1.419 0.606,-1.478 l 0.001,-0.004 c 0,0 0.136,0.083 0.143,0.269 0.009,0.219 0.231,0.717 0.785,0.716 0.598,-0.001 1.087,0.235 1.263,0.901 0.027,0.1 0.109,0.409 0.36,0.566 C -0.007,-0.084 0.018,-0.047 0,0",
    style: {
      fill: "#fddf87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5484"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5486",
    transform: "translate(118.1664,21.6095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.146,0.692 0.607,0.636 0.636,0.639 l 0,0 0.024,0.066 0.001,0 C 0.644,0.718 0.609,0.752 0.617,0.823 c 0.01,0.093 0.082,0.128 0.143,0.14 0.398,0.079 0.61,0.235 0.741,0.327 0.13,0.093 0.222,0.139 0.385,0.139 0.5,0 1.442,-0.734 1.726,-0.734 0.096,0 0.146,0.07 0.157,0.089 C 3.77,0.786 3.771,0.787 3.772,0.789 4.11,0.316 3.91,-0.146 3.772,-0.483 3.74,-0.56 3.191,-1.902 3.167,-1.961 L 3.166,-1.965 2.606,-3.327 C 2.35,-3.918 2.678,-4.347 2.678,-4.347 2.08,-4.348 1.409,-3.791 0.489,-2.289 -0.062,-1.388 -0.1,-0.474 0,0",
    style: {
      fill: "#fddf87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5488"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5490",
    transform: "translate(125.071,22.399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0.102,-0.286 0.361,-0.289 0.52,-0.242 0.662,-0.201 1.257,-0.008 1.57,0.115 1.883,0.239 1.964,0.182 2.125,0.11 2.599,-0.1 3.111,-0.084 3.111,-0.084 L 3.136,-0.15 C 2.742,-0.315 2.624,-0.486 2.427,-0.807 2.238,-1.113 1.864,-1.36 1.417,-1.36 1.07,-1.36 0.953,-1.216 0.782,-1.274 0.686,-1.307 0.587,-1.39 0.554,-1.588 0.475,-2.049 0.815,-2.565 0.606,-2.754 c 0,0 -0.574,1.402 -0.606,1.482 -0.138,0.336 -0.338,0.798 0,1.272",
    style: {
      fill: "#760135",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5492"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5494",
    transform: "translate(124.9587,16.9693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.074,0.085 -0.183,0.139 -0.304,0.139 -0.223,0 -0.404,-0.181 -0.404,-0.404 0,-0.057 0.012,-0.111 0.033,-0.16 l -0.779,-0.492 -0.782,0.492 c 0.022,0.049 0.033,0.103 0.033,0.16 0,0.223 -0.18,0.404 -0.403,0.404 -0.121,0 -0.23,-0.054 -0.304,-0.138 l -0.351,0.222 c 0,0 -0.464,0.302 -0.485,0.586 -0.009,0.113 0.068,0.208 0.203,0.02 0.056,-0.079 0.121,-0.177 0.302,-0.177 0.124,0 0.329,0.191 0.734,0.191 0.599,0 0.653,-0.271 1.052,-0.271 0.398,0 0.453,0.271 1.052,0.271 0.405,0 0.609,-0.191 0.734,-0.191 0.18,0 0.245,0.098 0.302,0.177 C 0.768,1.017 0.844,0.922 0.836,0.809 0.815,0.525 0.351,0.223 0.351,0.223 L 0,0 z",
    style: {
      fill: "#760135",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5496"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5498",
    transform: "translate(121.9382,22.399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -0.102,-0.286 -0.361,-0.289 -0.52,-0.242 -0.662,-0.201 -1.258,-0.008 -1.57,0.115 -1.883,0.239 -1.965,0.182 -2.125,0.11 -2.599,-0.1 -3.111,-0.084 -3.111,-0.084 L -3.136,-0.15 c 0.394,-0.165 0.512,-0.336 0.709,-0.657 0.189,-0.306 0.563,-0.553 1.01,-0.553 0.347,0 0.464,0.144 0.635,0.086 0.096,-0.033 0.195,-0.116 0.228,-0.314 0.079,-0.461 -0.494,-1.408 -0.248,-1.645 0,0 0.77,1.881 0.802,1.961 0.138,0.336 0.338,0.798 0,1.272",
    style: {
      fill: "#760135",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5500"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5502",
    transform: "translate(126.533,22.1007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-0.056 -0.045,-0.102 -0.101,-0.102 -0.057,0 -0.102,0.046 -0.102,0.102 0,0.056 0.045,0.102 0.102,0.102 C -0.045,0.102 0,0.056 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5504"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5506",
    transform: "translate(126.4902,21.3653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0.458,0 0.832,0.353 0.867,0.801 0.804,0.822 0.739,0.846 0.676,0.874 0.561,0.926 0.416,0.947 0.279,0.931 0.317,0.873 0.339,0.804 0.339,0.73 0.339,0.527 0.175,0.363 -0.028,0.363 -0.224,0.363 -0.384,0.516 -0.394,0.71 -0.563,0.644 -0.668,0.608 -0.816,0.57 -0.694,0.238 -0.375,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5508"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5510",
    transform: "translate(120.476,22.1007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-0.056 0.046,-0.102 0.102,-0.102 0.056,0 0.101,0.046 0.101,0.102 0,0.056 -0.045,0.102 -0.101,0.102 C 0.046,0.102 0,0.056 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5512"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5514",
    transform: "translate(120.5188,21.3653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.458,0 -0.832,0.353 -0.867,0.801 0.063,0.021 0.128,0.045 0.191,0.073 0.116,0.052 0.26,0.073 0.397,0.057 C -0.317,0.873 -0.34,0.804 -0.34,0.73 c 0,-0.203 0.165,-0.367 0.368,-0.367 0.196,0 0.356,0.153 0.366,0.347 C 0.563,0.644 0.668,0.608 0.816,0.57 0.694,0.238 0.375,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path5516"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBl);
export default __webpack_public_path__ + "static/media/bl.69cc57ef1950d1a32eedc71263c2359f.svg";
export { ForwardRef as ReactComponent };